<template>
  <div class="children-box">
    <div class="nav">
      <h3>添加商品</h3>
      <el-button style="font-size: 16px; width: 100px" plain @click="goBack"
        >返回</el-button
      >
    </div>
    <div class="procedure">
      <div class="firstStep" v-show="showFirst">
        <div class="step">
          <div class="item-num active-color size">1</div>
          <span class="item-text">选择商品</span>
          <div class="line"></div>
          <div class="item-num unactive-color size">2</div>
          <span class="item-text">填写基础信息</span>
          <!-- <div class="line"></div>
          <div class="item-num unactive-color size">3</div>
          <span class="item-text">修改商品详情</span> -->
        </div>
        <div class="select-product" @click="selectGoodDia">
          <span>选择商品：</span>
          <div class="step" style="justify-content: center">
            <i
              v-if="!goodsImg"
              class="el-icon-s-goods"
              style="font-size: 45px; color: #767676"
            ></i>
            <img
              v-else
              style="width: 100%; height: 100%"
              :src="goodsImg"
              alt=""
            />
          </div>
        </div>

        <div class="next-btn" @click="nextTwo">下一步</div>
      </div>
      <div class="twoStep" v-show="showTwo">
        <div class="step">
          <div class="item-num active-color size">1</div>
          <span class="item-text">选择商品</span>
          <div class="line"></div>
          <div class="item-num active-color size">2</div>
          <span class="item-text">填写基础信息</span>
          <!-- <div class="line"></div>
          <div class="item-num unactive-color size">3</div>
          <span class="item-text">修改商品详情</span> -->
        </div>
        <el-form :model="formData" ref="ruleForm" label-width="100px">
          <el-form-item label="商品主图：" prop="listImg">
            <template slot="label">
              <span><span style="color: red">*</span>商品主图：</span>
            </template>
            <el-upload
              class="avatar-uploader"
              :action="$uploadURL"
              :show-file-list="false"
              :on-success="handleAddUploadSuccess"
              :before-upload="beforeUpload"
            >
              <img
                v-if="formData.listImg"
                :src="formData.listImg"
                class="avatar"
                style="width: 146px; height: 146px"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="商品轮播图：" prop="bannerUrl" label-width="120">
            <template slot="label">
              <span><span style="color: red">*</span>商品轮播图：</span>
            </template>
            <el-upload
              :show-file-list="true"
              list-type="picture-card"
              :action="$uploadURL"
              :on-success="handSuccess"
              :on-remove="handleRemove"
              :file-list="fileList"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="名称" prop="productName">
            <template slot="label">
              <span><span style="color: red">*</span>商品名称：</span>
            </template>
            <el-input v-model="formData.productName"></el-input>
          </el-form-item>

          <el-form-item label="总购买数量限制" label-width="200">
            <template slot="label">
              <span><span style="color: red">*</span>总购买数量限制：</span>
            </template>
            <el-input type="number" v-model="formData.limitNum" @input="handleTotalInput($event)"></el-input>
          </el-form-item>

          <el-form-item label="上架状态">
            <el-radio-group v-model="formData.productStatus">
              <el-radio :label="2" >否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- <el-form-item label="参与站点">
            <div class="step">
              <el-input
                readonly
                type="textarea"
                style="width: 300px"
                v-model="siteChangeName"
              ></el-input>
              <el-button
                @click="dialogSite = true"
                style="margin-left: 10px"
                type="primary"
                >选择站点</el-button
              >
            </div>
          </el-form-item> -->

          <el-form-item label="规格选择：" label-width="200">
            <div style="padding: 10px 20px">
              <el-table
                ref="refSpecification"
                :data="specificationList"
                style="width: 90%"
                border
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55" align="center" v-if="!parentId">
                </el-table-column>
                <el-table-column
                  prop="skuName"
                  label="规格名称"
                  width="120"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop=""
                  label="图片"
                  width="130"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <img
                      style="width: 100px; height: 100px"
                      :src="row.skuImg"
                      alt=""
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  prop="score"
                  label="兑换积分"
                  width="150"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.score"
                      placeholder="请输入"
                      type="number"
                      :min="0"
                      :style="{ width: '80%' }"
                      @input="handleInput($event, scope.$index, 1)"
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  prop="scorePrice"
                  label="价格"
                  width="150"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.scorePrice"
                      placeholder="请输入"
                      type="number"
                      :min="0"
                      :style="{ width: '80%' }"
                      @input="handleInput($event, scope.$index, 2)"
                    />
                  </template>
                </el-table-column>

                <el-table-column
                  prop="sellPrice"
                  label="原价"
                  width="100"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="stock"
                  label="库存"
                  width="100"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="size"
                  label="商品尺寸"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="netWeight"
                  label="重量"
                  width="100"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="unit"
                  label="单位"
                  width="100"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="volume"
                  label="体积"
                  width="100"
                  align="center"
                >
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>

        <div class="btn-box">
          <!-- <div class="last-btn" @click="lastFirst">上一步</div> -->
          <div class="next-btn" @click="submit">提交</div>
        </div>
      </div>
      <div class="threeStep" v-show="showThree">
        <div class="step">
          <div class="item-num active-color size">1</div>
          <span class="item-text">选择商品</span>
          <div class="line"></div>
          <div class="item-num active-color size">2</div>
          <span class="item-text">填写基础信息</span>
          <!-- <div class="line"></div>
          <div class="item-num active-color size">3</div>
          <span class="item-text">修改商品详情</span> -->
        </div>
        <div style="margin-top: 20px">
          <quill-editor
            v-model="formData.detail"
            ref="myQuillEditor"
            :options="editorOption"
            placeholder="请输入内容"
          >
          </quill-editor>
        </div>
        <div class="btn-box">
          <div class="last-btn" @click="lastTwo">上一步</div>
          <div
            class="next-btn"
            @click="submit"
          >
            提交
          </div>
        </div>
      </div>

    </div>
    <el-dialog
      title="选择商品"
      center
      :visible.sync="dialogVisible"
      width="70%"
    >
      <div class="select-box">
        <div>
          <el-row :gutter="10">
            <el-col :span="7">
              <div class="item-col">
                <span class="label">商品名称 </span>
                <div>
                  <el-input
                    v-model="goodsSearch.condition.productName"
                    style="width: 100%"
                    placeholder="请输入内容"
                  ></el-input>
                </div></div
            ></el-col>
            <el-col :span="7">
              <div class="item-col">
                <span class="label">商品分类 </span>
                <div>
                  <el-select
                    v-model="goodsSearch.condition.categoryFirstCode"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in categoryList"
                      :key="item.categoryCode"
                      :label="item.categoryName"
                      :value="item.categoryCode"
                    >
                    </el-option>
                  </el-select>
                </div></div
            ></el-col>

            <el-col :span="5"
              ><el-button
                type="primary"
                icon="el-icon-search"
                @click="searchGoods"
                >查询</el-button
              >
              <el-button type="info" icon="el-icon-refresh" @click="restGoods"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div style="height: 300px; overflow-y: auto">
          <el-table
            :data="goodsData.goodsList"
            height="100%"
            style="width: 100%"
            border
          >
            <el-table-column prop="productName" label="商品名称" align="center">
            </el-table-column>

            <el-table-column prop="name" label="商品图片" align="center">
              <template slot-scope="{ row }">
                <img
                  style="width: 50px; height: 50px"
                  :src="row.listImg"
                  alt=""
                />
              </template>
            </el-table-column>

            <el-table-column
              prop="categoryFirstName"
              label="一级分类"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="categorySecondName"
              label="二级分类"
              align="center"
            >
            </el-table-column>

            <!-- <el-table-column prop="address" label="可销售库存" align="center">
            </el-table-column> -->
            <el-table-column prop="address" label="商品状态" align="center">
              <template slot-scope="{ row }">
                <el-button v-if="row.productStatus == 1" type="success"
                  >进行中</el-button
                >
                <el-button v-if="row.productStatus == 2" type="danger"
                  >已下架</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="" width="100">
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  size="small"
                  @click="selectGoods(row.productCode, row.listImg)"
                  >选择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="goodsData.count"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 参与站点 -->
    <!-- <el-dialog title="选择站点" center :visible.sync="dialogSite" width="70%">
      <div class="select-box">
        <div>
          <el-row :gutter="10">
            <el-col :span="7">
              <div class="item-col">
                <span class="label">提货点名称</span>
                <div>
                  <el-input
                    v-model="sietSearch.condition.siteName"
                    style="width: 100%"
                    placeholder="请输入提货点名称"
                  ></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="7">
              <div class="item-col">
                <span class="label">提货点联系人 </span>
                <div>
                  <el-input
                    v-model="sietSearch.condition.linkMemberName"
                    style="width: 100%"
                    placeholder="请输入联系人"
                  ></el-input>
                </div></div
            ></el-col>
            <el-col :span="7">
              <div class="item-col">
                <span class="label">联系人手机号 </span>
                <div>
                  <el-input
                    v-model="sietSearch.condition.linkPhone"
                    style="width: 100%"
                    placeholder="请输入手机号"
                  ></el-input>
                </div></div
            ></el-col>
            <el-col :span="7">
              <div class="item-col">
                <span class="label">营业状态 </span>
                <div>
                  <el-select
                    @change="searchSite"
                    v-model="sietSearch.condition.status"
                    placeholder="请选择营业状态"
                    style="width: 100%"
                  >
                    <el-option label="全部" value=""> </el-option>
                    <el-option label="营业" :value="1"> </el-option>
                    <el-option label="休息" :value="2"> </el-option>
                  </el-select>
                </div></div
            ></el-col>
            <el-col :span="5"
              ><el-button
                type="primary"
                icon="el-icon-search"
                @click="searchSite"
                >查询</el-button
              >
              <el-button type="info" icon="el-icon-refresh" @click="resetSite"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div style="height: 400px; overflow-y: auto">
          <el-table
            ref="multipleTable"
            :data="siteData.siteList"
            height="100%"
            style="width: 100%"
            border
            @selection-change="handleSelectionSite"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="siteName" label="提货点名称（站点）">
            </el-table-column>
            <el-table-column prop="linkMemberName" label="联系人姓名">
            </el-table-column>
            <el-table-column prop="linkPhone" label="联系人手机号">
            </el-table-column>
            <el-table-column prop="address" label="营业状态">
              <template slot-scope="{ row }">
                <el-button v-if="row.status == 1" type="success"
                  >营业</el-button
                >
                <el-button v-if="row.status == 2" type="danger">休息</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="display: flex; justify-content: flex-end">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="goodsData.count"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSite = false">取 消</el-button>
        <el-button type="primary" @click="submitSite">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    quillEditor
  },
  props: ['parentId'],
  data () {
    return {
      formData: {
        id: this.parentId,
        productSkuScore: '',
        creator: '', // 创建人
        productCode: '', // 商品Code
        listImg: '',
        bannerImgList: [],
        productName: '',
        introduce: '',
        startTime: '',
        endTime: '',
        isExpressDelivery: 0, // 快递
        isTeamDelivery: 0, // 团长
        isVipDelivery: 0, // 专享
        isSelfPickup: 0, // 自提
        limitNum: undefined, // 限制数量
        productSkuList: [], // 选择规格，
        // memberTeamSiteList: [], //站点
        detail: '', // 富文本内容,
        rule: '' // 砍价规则
      },
      specificationList: [],
      goodsImg: '',
      // sietChangeList: [], //选择站点
      // siteChangeName: "",
      // sietSearch: {
      //   condition: {
      //     siteName: "",
      //     linkMemberName: "",
      //     linkPhone: "",
      //     status: "",
      //   },
      //   count: 0,
      //   currPage: 1,
      //   pageCount: 0,
      //   pageSize: 10,
      // },
      // siteData: {
      //   siteList: [],
      //   count: 0,
      // },
      goodsSearch: {
        condition: {
          categoryFirstCode: '',
          productName: ''
        },
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 10
      },
      goodsData: {
        count: 0,
        goodsList: []
      },
      fileList: [],
      favorableTime: [],
      showThree: false,
      showTwo: false,
      showFirst: true,
      dialogVisible: false,
      // dialogSite: false,
      input: '',
      categoryList: [],

      editorOption: {
        theme: 'snow',
        bounds: document.body,
        debug: 'warn',
        modules: {
          // 工具栏配置
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
            ['blockquote', 'code-block'], // 引用  代码块
            [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
            [{ indent: '-1' }, { indent: '+1' }], // 缩进
            [{ size: ['small', false, 'large', 'huge'] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ align: [] }], // 对齐方式
            ['clean'], // 清除文本格式
            ['link', 'image', 'video'] // 链接、图片、视频
          ]
        },
        placeholder: '请输入内容,不超过300字',
        readOnly: this.readOnly
      }
    }
  },
  async created () {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.formData.creator = userInfo.userInfo.nickName
    await this.getAllGoods()
    await this.getAllParentCategoryList()
    // await this.getAllSite();
    console.log('3232', this.parentId)
    if (this.parentId) {
      this.getEditScoreInfo()
      this.goTwo()
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.goodsSearch.currPage = val
      this.getAllGoods()
    },
    handleTotalInput (value) {
      if (isNaN(value) || value < 0) {
        this.formData.limitNum = ''
        this.$message({
          message: '此项不能为负数！',
          type: 'fail'
        })
      }
    },
    handleInput (value, index, type) {
      if (isNaN(value) || value < 0) {
        if (type == 1) {
          this.specificationList[index].groupNum = ''
        } else if (type == 2) {
          this.specificationList[index].groupPrice = ''
        }
        this.$message({
          message: '此项不能为负数！',
          type: 'fail'
        })
      }
    },
    // 回显数据(营销活动)
    getEditScoreInfo () {
      this.$http
        .post('/productSocre/queryDetail', {
          id: this.parentId
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.formData = res.data.data
            this.fileList = res.data.data.bannerImg.split(',').map((f) => {
              return { url: f }
            })
            this.formData.productSkuList = res.data.data.productSkuScoreList
            this.specificationList = res.data.data.productSkuScoreList
          }
        })

      // let _this = this;
      // this.$http
      //   .post("/productSocre/queryDetail", {
      //     id: this.parentId,
      //   })
      //   .then(function (res) {
      //     let { code, data } = res.data;
      //     if (code == 200) {
      //       // console.log(data);
      //       // 第一部分回显
      //       _this.formData.productCode = data.productCode;
      //       _this.goodsData.goodsList.forEach((f) => {
      //         if (f.productCode == data.productCode) {
      //           _this.goodsImg = f.listImg;
      //         }
      //       });
      //       // 第二部分回显
      //       _this.formData.listImg = data.listImg;
      //       _this.formData.bannerImgList = data.bannerImgList;
      //       _this.fileList = data.bannerImgList.map((f) => {
      //         return { url: f };
      //       });
      //       _this.formData.productName = data.productName;
      //       _this.formData.introduce = data.introduce;
      //       _this.favorableTime = [data.startTime, data.endTime];
      //       _this.formData.isExpressDelivery = data.isExpressDelivery;
      //       _this.formData.isTeamDelivery = data.isTeamDelivery;
      //       _this.formData.isVipDelivery = data.isVipDelivery;
      //       _this.formData.isSelfPickup = data.isSelfPickup;
      //       _this.formData.memberTeamSiteList = data.memberTeamSiteList;
      //       _this.formData.productSkuList = data.productSkuActivityList;
      //       _this.specificationList = data.productSkuActivityList;
      //       console.log("321", _this.specificationList);
      //       _this.formData.detail = data.detail;
      //     }
      //   });
    },

    // 新增提交
    submit () {
      let _this = this
      let formData = {
        ...this.formData,
        bannerImgList: this.fileList.length
          ? this.fileList.map((f) => f.url)
          : []
      }
      this.$http
        .post('/productSocre/save', {
          ...formData,
          merchantName:localStorage.getItem("merchantName")
        })
        .then(function (res) {
          console.log(res)

          let { code } = res.data
          if (code === 200) {
            _this.$message({
              message: '保存成功!',
              type: 'success'
            })
            _this.goBack()
          } else {
            _this.$message({
              message: res.data.message,
              type: 'fail'
            })
          }
        })
    },
    // submitSite() {
    //   this.formData.memberTeamSiteList = this.sietChangeList;
    //   this.dialogSite = false;
    // },
    // handleSelectionSite(data) {
    //   if (data.length) {
    //     this.sietChangeList = data;
    //     this.siteChangeName = data.map((f) => f.siteName).join(",");
    //   }
    // },
    handleSelectionChange (data) {
      this.formData.productSkuList = data
    },
    changeTime (data) {
      if (data) {
        this.formData.startTime = data[0]
        this.formData.endTime = data[1]
      } else {
        this.favorableTime = []
        this.formData.startTime = ''
        this.formData.endTime = ''
      }
    },
    selectGoods (productCode, listImg) {
      this.formData.productCode = productCode
      this.goodsImg = listImg
      this.dialogVisible = false
    },
    // 获取所有站点
    // getAllSite() {
    //   let _this = this;
    //   this.$http
    //     .post("/memberTeamSite/list", {
    //       ..._this.sietSearch,
    //     })
    //     .then(function (res) {
    //       let { code, data } = res.data;
    //       if (code === 200) {
    //         _this.siteData.siteList = data.data;
    //         _this.siteData.count = data.count;
    //       }
    //     });
    // },
    // 获取所有商品
    getAllGoods () {
      let _this = this
      this.$http
        .post('/product/list', {
          ..._this.goodsSearch
        })
        .then(function (res) {
          let { count, currPage, data, pageCount, pageSize } = res.data.data
          _this.goodsData.goodsList = data
          _this.goodsData.count = count
        })
    },
    // 获取所有一级分类
    getAllParentCategoryList () {
      this.$http
        .post('/productCategory/queryList', {
          level: 1
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.categoryList = res.data.data
          }
        })
    },
    // searchSite() {
    //   this.searchSite.currPage = 1;
    //   this.getAllSite();
    // },
    // resetSite() {
    //   this.sietSearch.condition.siteName = "";
    //   this.sietSearch.condition.linkMemberName = "";
    //   this.sietSearch.condition.linkPhone = "";
    //   this.sietSearch.condition.status = "";
    //   this.sietSearch.currPage = 1;
    //   this.siteData.pageCount = 0;
    //   this.siteData.pageSize = 10;
    //   this.getAllSite();
    // },
    searchGoods () {
      this.searchGoods.currPage = 1
      this.getAllGoods()
    },
    restGoods () {
      this.goodsSearch.condition.productCode = ''
      this.goodsSearch.condition.productName = ''
      this.goodsSearch.currPage = 1
      this.goodsData.pageCount = 0
      this.goodsData.pageSize = 10
      this.getAllGoods()
    },

    lastTwo () {
      this.showThree = false
      this.showTwo = true
    },
    lastFirst () {
      this.showFirst = true
      this.showTwo = false
    },
    nextThree () {
      if (!this.formData.listImg) {
        return this.$message({
          message: '请上传商品主图',
          type: 'warning'
        })
      }
      if (!this.fileList.length) {
        return this.$message({
          message: '请上传商品轮播图',
          type: 'warning'
        })
      }
      if (!this.formData.productName) {
        return this.$message({
          message: '请输入商品名称',
          type: 'warning'
        })
      }
      if (!this.formData.limitNum) {
        return this.$message({
          message: '请输入总购买数量限制',
          type: 'warning'
        })
      }
      if (!this.formData.productStatus) {
        return this.$message({
          message: '请选择上架状态',
          type: 'warning'
        })
      }
      this.showTwo = false
      this.showThree = true
    },
    async nextTwo () {
      if (!this.formData.productCode) {
        return this.$message({
          message: '请先选择商品！',
          type: 'warning'
        })
      }
      if (!this.parentId) {
        await this.getProductInfo()
        await this.getGoodsSpecification()
      }
      this.showFirst = false
      this.showTwo = true
    },

    async goTwo () {
      if (!this.parentId) {
        await this.getProductInfo()
        await this.getGoodsSpecification()
      }
      this.showFirst = false
      this.showTwo = true
    },

    // 回显数据(商品信息)
    getProductInfo () {
      let _this = this
      this.$http
        .post('/product/queryOne', {
          productCode: this.formData.productCode
        })
        .then(function (res) {
          let { code, data } = res.data
          if (code == 200) {
            _this.formData.listImg = data.listImg
            // _this.formData.bannerImgList = data.bannerImgList;
            _this.formData.bannerImgList = data.bannerImg
              .split(',')
              .map((item) => item.trim())
            _this.fileList = _this.formData.bannerImgList.map((f) => {
              return { url: f }
            })
            _this.formData.productName = data.productName
            _this.formData.introduce = data.productIntro
            _this.formData.isExpressDelivery = data.isExpressDelivery
            _this.formData.isTeamDelivery = data.isTeamDelivery
            _this.formData.isVipDelivery = data.isVipDelivery
            _this.formData.isSelfPickup = data.isSelfPickup
            _this.formData.memberTeamSiteList = data.memberTeamSiteList
            _this.formData.limitNum = data.purchaseLimit
          }
        })
    },

    // 获取规格列表
    getGoodsSpecification () {
      let _this = this
      this.$http
        .post('/productSku/queryList', {
          productCode: _this.formData.productCode
        })
        .then(function (res) {
          let { code, data } = res.data
          if (code == 200) {
            _this.specificationList = data
            if (_this.parentId) {
              _this.$nextTick(() => {
                _this.specificationList.forEach((f) => {
                  _this.formData.productSkuList.forEach((s) => {
                    if (f.id == s.id) {
                      _this.$refs.refSpecification.toggleRowSelection(f, true)
                    }
                  })
                })
              })
            }
          }
        })
    },

    selectGoodDia () {
      this.dialogVisible = true
    },
    handSuccess (file) {
      this.fileList.push({
        url: file.data.url
      })
    },
    handleRemove (file, fileList) {
      let picArr = []
      if (fileList?.length) {
        fileList.forEach((item) => {
          picArr.push({
            url: item.url
          })
        })
        this.fileList = picArr
      } else {
        this.fileList = []
      }
    },
    // 图片上传成功处理
    handleAddUploadSuccess (res, file) {
      this.formData.listImg = file.response.data.url
      //   this.$forceUpdate(); // 触发强制刷新
    },
    // 图片上传之前处理
    beforeUpload (file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    },
    goBack () {
      this.$emit('goBack')
    }
  }
}
</script>

<style lang="less" scoped>
.children-box {
  .nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
  }
  .procedure {
    .firstStep {
      margin-top: 50px;
      padding-left: 100px;
      .select-product {
        display: flex;
        margin-top: 50px;
        div {
          width: 100px;
          height: 100px;
          border: 1px solid #999;
        }
      }
    }
    .twoStep {
      margin-top: 50px;
      padding-left: 100px;
    }
    .threeStep {
      margin-top: 50px;
      padding: 0 100px;
    }
    .fourStep {
      margin-top: 50px;
      padding: 0 100px;
    }
  }
}
.select-box {
  .item-col {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    .label {
      margin-right: 10px;
    }
    div {
      flex: 1;
    }
  }
}
.step {
  display: flex;
  align-items: center;
}
.item-num {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.active-color {
  background-color: #1e98d7;
  color: #fff;
}
.size {
  display: flex;
  align-items: center;
  justify-content: center;
}
.unactive-color {
  border: 0.5px solid #adadad;
  border-color: #adadad;
}
.item-text {
  margin: 0 10px;
}
.line {
  width: 80px;
  height: 0.5px;
  border-top: 1px solid #adadad;
  margin: 0 10px;
}
.last-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  margin-top: 50px;
  margin-left: 50px;
  border: 1px solid #adadad;
  border-radius: 10px;
  color: #333;
  cursor: pointer;
}
.next-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  margin-top: 50px;
  margin-left: 70px;
  background-color: #1e98d7;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
}
.btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 20px;
  div {
    transform: translateX(-60%);
  }
}
/deep/ .el-form {
  margin-top: 50px;
  .el-input {
    width: 300px;
  }
  .el-input-number {
    .el-input__inner {
      width: 100px;
    }
  }
}
.avatar {
  width: 146px;
  height: 146px;
  display: block;
}
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 146px;
  height: 146px;
  line-height: 146px;
  text-align: center;
}
</style>
